import { __rest } from "tslib";
import React from 'react';
import Position from './Position';
const Absolute = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Position, Object.assign({ position: "absolute", ref: ref }, props), children));
});
export default Absolute;
